import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const NewsItem = (props) => {
  return (
    <Grid item lg={4} md={6} sm={12} xs={12}>
      <Box className="gr-blog-item">
        <Box className="gr-blog-image">
          {props?.link_type === "standard" ? (
            <a href={"/aktuelles/" + props.data.news.path_segment}>
              <Box className="gr-blog-meta-category-patch">
                <Typography>{props.data.categories[0]}</Typography>
              </Box>
              <img
                className="gr-blog-featured-image"
                src={"https://ganzrund.com/" + props.data.files[0].publicUrl}
              />
            </a>
          ) : (
            <Link to={props.data.news.path_segment}>
              <Box className="gr-blog-meta-category-patch">
                <Typography>{props.data.categories[0]}</Typography>
              </Box>
              <img
                className="gr-blog-featured-image"
                src={"https://ganzrund.com/" + props.data.files[0].publicUrl}
              />
            </Link>
          )}
        </Box>
        <Box className="gr-blog-item-content">
          <Box className="gr-blog-item-head">
            <Box className="gr-blog-meta-data">
              <Typography className="gr-blog-meta-category">
                {props.data.categories[0]}
              </Typography>{" "}
              <Typography sx={{ display: "inline" }}>
                - {props.data.news.crdate}{" "}
              </Typography>
              <Typography className="gr-blog-meta-read-time-patch">
                {props.data.news.readtime}min lesen
              </Typography>
            </Box>
            <Box className="gr-blog-title">
              {props?.link_type === "standard" ? (
                <a href={"/aktuelles/" + props.data.news.path_segment}>
                  <Typography
                    sx={{ fontSize: "25px !important" }}
                    component="h2"
                  >
                    {props.data.news.title}
                  </Typography>
                </a>
              ) : (
                <Link to={props.data.news.path_segment}>
                  <Typography
                    sx={{ fontSize: "25px !important" }}
                    component="h2"
                  >
                    {props.data.news.title}
                  </Typography>
                </Link>
              )}
            </Box>
          </Box>
          <Box className="gr-blog-item-body">
            <Typography>{props.data.news.teaser}</Typography>
          </Box>
          <Box className="gr-blog-item-footer">
            <Box className="gr-blog-item-author">
              <Box className="gr-blog-author-avatar">
                <img
                  src={
                    props.data.news.author === "Chiara erklärt"
                      ? "https://ganzrund.com/fileadmin/user_upload/chiara.jpg"
                      : "https://ganzrund.com/_assets/7bd9c8c8de0c98603b46240c0ed70db7/Images/fav.jpg"
                  }
                />
              </Box>
              <Typography>
                {props.data.news.author !== "" ? "von Chiara" : "GANZRUND Team"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default NewsItem;
